import { STATUS_META } from "../lib/constants";

export default function StatusBadge({ status, size = "sm" }) {
  const meta = STATUS_META[status] || { label: status, bg: "#F3F4F6", fg: "#374151" };
  const padding = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-1 text-[0.65rem]";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center font-bold uppercase tracking-widest ${padding}`}
      style={{ background: meta.bg, color: meta.fg, borderRadius: 0 }}
    >
      {meta.label}
    </span>
  );
}
